import { render, staticRenderFns } from "./ArticleItemSimple.vue?vue&type=template&id=9a001602&scoped=true&"
import script from "./ArticleItemSimple.vue?vue&type=script&lang=js&"
export * from "./ArticleItemSimple.vue?vue&type=script&lang=js&"
import style0 from "./ArticleItemSimple.vue?vue&type=style&index=0&id=9a001602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a001602",
  null
  
)

export default component.exports